import axios from 'axios';
import React, { useRef, useState } from 'react'
import { Link, useLocation } from 'wouter';
import { api } from '../../settings/env';

export default function SearchBarMobile() {

    const [states, setStates] = useState([
        { "estado": "Amazonas" },
        { "estado": "Anzoátegui" },
        { "estado": "Apure" },
        { "estado": "Aragua" },
        { "estado": "Barinas" },
        { "estado": "Bolívar" },
        { "estado": "Carabobo" },
        { "estado": "Cojedes" },
        { "estado": "Delta Amacuro" },
        { "estado": "Falcón" },
        { "estado": "Guárico" },
        { "estado": "Lara" },
        { "estado": "Mérida" },
        { "estado": "Miranda" },
        { "estado": "Monagas" },
        { "estado": "Nueva Esparta" },
        { "estado": "Portuguesa" },
        { "estado": "Sucre" },
        { "estado": "Táchira" },
        { "estado": "Trujillo" },
        { "estado": "La Guaira" },
        { "estado": "Yaracuy" },
        { "estado": "Zulia" },
        { "estado": "Distrito Capital" }
    ]
    );

    const [data, setData] = useState("");
    const inputSearch = useRef();
    const [location, setLocation] = useLocation();

    const search = () => {
        // TODO: Implement search functionality
        setLocation("search");
    }

    const searchProfessional = (e) => {
        console.log("Search.. ", inputSearch.current.value);

        if (inputSearch.current.value != "") {
            searching(inputSearch.current.value);
        } else {
            setData("");
        }

    }

    const searching = (value) => {
        axios.get(`${api}/register/search/${value}`)
            .then(response => {
                setData(response.data)
            })
            .catch(error => console.error(error));
    }

    return (
        <div>
            <div className="search-bar mobile">

                {
                    data.length > 0 && <div className="box-result">
                        {data.length} resultado{data.length > 1 ? "s" : ""}

                        {
                            data.length > 0 && data.map((item, index) => (
                                <div className="box-card" key={index}>
                                    <img
                                        width={"100%"}
                                        src={item.profilePicture}
                                        alt=""
                                    />

                                    <div className="details">
                                        <span>{item.type}</span>
                                        <h3>{item.fullName}</h3>
                                        <p>{item.description}</p>

                                        <Link to={`/provider-profile/${item.id}`}>
                                            <button className="btn btn-primary">
                                                Click aqui
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                }

                <button className="btn btn-primary" style={{ width: "19%" }}>
                    <img src="/assets/icons/location-pin.svg" width={"19px"} alt="" />
                </button>
{/* 
                <select class="form-select" style={{ width: "320px", marginRight: "10px" }}>
                    <option selected>Selecciona un estado</option>
                    {
                        states.map((item, index) => (
                            <option key={index} value={item.estado}>
                                {item.estado}
                            </option>
                        ))
                    }
                </select> */}

                <input

                    ref={inputSearch}
                    onKeyUp={searchProfessional}
                    className="form-control"
                    placeholder="Busca profesionales de salud, medicamentos y servicios cerca de ti..."
                    type="text"
                />

                <button className="btn btn-primary" onClick={search}>
                    <img src="/assets/icons/search.svg" alt="" />
                </button>


            </div>
        </div>
    )
}
